import React, { Fragment, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner, Input, ModalFooter } from 'reactstrap';
import { ButtonC } from 'Common/Buttons';
import { DAM_SVG } from 'components/Dam/DamAssets';
import close from '../../../../assets/V2-images/close.svg';
import InputC from 'Common/Inputs/index.tsx';
import Axios, { header } from 'functions/Axios';
import {
  AddCollection,
  createCollectionURL,
  ListofCollectionsURL,
} from 'components/Dam/DAM_API/urls';
import { toast } from 'react-toastify';

const AddToCollectionCommonModal = ({
  OpenModal = true,
  ToggleModal,
  Data,
  isMultiple = false,
  HandleAssetMove,
}) => {
  const [folderModalOpen, setFolderModalOpen] = useState(false);
  const [folderName, setFolderName] = useState();
  const [collectionData, setCollectionData] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState([]);
  const [loaders, setLoaders] = useState({
    moving: false,
    folder: false,
  });

  const closeBtn2 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => ToggleModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const moveToAssetHandler = async () => {
    try {
      setLoaders((prev) => ({
        ...prev,
        moving: true,
      }));
      const multipleBodyData = selectedCollection?.map((item, index) => ({
        collectionId: item?.collectionID,
        collectionName: item?.collection_name,
        damIdsList: Array.isArray(Data) ? Data : [Data],
      }));

      const result = await Axios.post(createCollectionURL, multipleBodyData, header);
      toast.success(result?.data?.message);
      setLoaders((prev) => ({
        ...prev,
        moving: false,
      }));
      ToggleModal();
    } catch (err) {
      setLoaders((prev) => ({
        ...prev,
        moving: false,
      }));
      console.error(err);
    }
  };

  const createFolderHandler = async () => {
    try {
      const body = [
        {
          collectionName: folderName,
        },
      ];

      const response = await Axios.post(AddCollection, body);
      fetchData();
      setFolderModalOpen(!folderModalOpen);
    } catch (err) {
      console.error(err);
    }
  };
  const fetchData = async () => {
    try {
      const response = await Axios.get(`${ListofCollectionsURL}?pageNo=0&rowSize=20`);
      setCollectionData(response?.data?.data?.collections);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Fragment>
      <Modal
        isOpen={OpenModal}
        toggle={ToggleModal}
        style={{ maxWidth: '660px', width: '660px', maxHeight: '70vh', overflow: 'auto' }}
      >
        <div>
          {folderModalOpen && <div className="external_background_event"></div>}
          <ModalHeader toggle={ToggleModal} close={closeBtn2}>
            Add To Collection
          </ModalHeader>
          <ModalBody
            style={{
              position: 'relative',
              height: '60vh',
            }}
          >
            <div
              className="dis_grid"
              style={{
                maxHeight: '50vh',
                overflow: 'auto',
              }}
            >
              {collectionData?.map((item, index) => (
                <div
                  className={`d-flex align-items-center  gap-2 dam_common_hover`}
                  style={{
                    paddingTop: '16px',
                    paddingBottom: '16px',
                    borderRadius: '0px',
                    border: 'none',
                    borderBottom: '1px solid #ededed',
                  }}
                  // onClick={() => {
                  //   setSelectedCollection(item);
                  // }}
                >
                  <div
                    style={{
                      paddingLeft: '7px',
                    }}
                  >
                    {' '}
                    <InputC
                      type="Checkbox"
                      size="md"
                      change={(e) => {
                        if (e.target.checked) {
                          setSelectedCollection((prev) => [...prev, item]);
                        } else {
                          setSelectedCollection((prev) =>
                            prev.filter((i) => i.collectionID !== item.collectionID),
                          );
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      backgroundImage: `url(${item?.thumbNailPath?.[0]})`,
                      backgroundColor: '#D9D9D9',
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      height: '104px',
                      width: '104px',
                      position: 'relative',
                    }}
                  ></div>

                  <div>
                    <div className="permission_header">{item?.collection_name}</div>
                    <div
                      className="permission_data_description"
                      style={{
                        marginTop: '4px',
                      }}
                    >
                      Created by: {item?.createdBy}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* {collectionData?.map((item, index) => ())} */}

            {/* Footer Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-3">
              <div>
                <ButtonC
                  text={
                    <div className="d-flex gap-1 align-items-center">
                      <div className="d-flex">{DAM_SVG.collectionSvg}</div>
                      <div>New Collection</div>
                    </div>
                  }
                  color="Tertiary"
                  click={() => {
                    setFolderModalOpen(!folderModalOpen);
                  }}
                  size="lg"
                />
              </div>
              <div>
                <ButtonC text="Cancel" color="Secondary" click={ToggleModal} size="lg" />
              </div>
              {selectedCollection?.length > 0 && (
                <div>
                  {/* Submit button -> Enter key also triggers this */}
                  <ButtonC
                    text=""
                    type="submit"
                    size="lg"
                    click={moveToAssetHandler}
                    disabled={loaders.moving}
                  >
                    {loaders?.moving && <Spinner color="light" className="mx-1" size="sm" />} Done
                  </ButtonC>
                </div>
              )}
            </div>
          </ModalBody>
        </div>
      </Modal>
      <Modal isOpen={folderModalOpen} style={{ width: '50vw' }}>
        <ModalHeader   toggle={()=>setFolderModalOpen(pre=>!pre)}>
          Create New Collection{' '}
        </ModalHeader>
        <ModalBody>
          <div>
            <div className="d-flex justify-content-between"></div>
            <InputC
              type="text"
              placeholder=""
              size="lg"
              label="Collection Name"
              change={(e) => {
                setFolderName(e.target.value);
              }}
              inputvalue={folderName}
            />

          </div>
        </ModalBody>
        <ModalFooter style={{border:"none"}}>
          
            <div className="d-flex justify-content-end gap-2">
              <div>
                <div
                  className="Primary-Button large-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    createFolderHandler();
                  }}
                  disabled={loaders?.folder}
                >
                  {loaders?.folder && <Spinner color="light" className="mx-1" size="sm" />} Create
                </div>
              </div>
            </div>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default AddToCollectionCommonModal;
